///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';
import { GtthModifyLinkInfoCommand } from './modify-link-info-command';
import { GtthPreloaderModalEvent } from '../../../../../shared/preloader-modal/preloader-modal-event';
import { GtthLinkFeatureDtoModel } from '../../../../../services/project-socket/dto/gtth-link-feature-dto.model';
import { TopologyLinkTypeEnum } from '../../../../../services/project-socket/dto/topology-types.model';
import { _cloneDeep } from '../../../../../shared/utils';

export class GtthVerifyLosesToStationNeighborsCommand extends GtthAbstractCommand {
    private losesId: number[];
    private losesList: GtthLinkFeatureDtoModel[];
    private stationId: number;

    getCommandName(): string {
        return 'GtthVerifyLosesToStationNeighborsCommand';
    }

    create(stationId: number): this {
        this.stationId = stationId;

        if (!this.losesId) {
            this.losesId = this.historyService.logicalTopology.getExistLosForStation(this.stationId);
            this.losesList = this.losesId.map((losId: number) => {
                return this.historyService.logicalTopology.getLink(losId).toGeoJson();
            });
        }

        return this;
    }

    doCommand(): void {
        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.show('Loading')
        });

        const links = this.losesList.map((losJson: GtthLinkFeatureDtoModel) => {
            const newLosJson: GtthLinkFeatureDtoModel = _cloneDeep(losJson);
            newLosJson.setLinkType(TopologyLinkTypeEnum.CONFIRMED_LOS);
            return newLosJson;
        });

        const activity = this.createActivityDTO(false);
        activity.links = [...links];
        this.sendActivity(activity);
    }

    undoCommand(): void {
        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.show('Loading')
        });

        const activity = this.createActivityDTO(false);
        activity.links = [...this.losesList];
        this.sendActivity(activity);
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        this.activityHandler(activityDto);
    }

    undoCommandActivity(activityDto: ActivityDTO): void {
        this.activityHandler(activityDto);
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }

    isModifyTopology(): boolean {
        return true;
    }

    isClearDesign(): boolean {
        return true;
    }

    private activityHandler(activityDto: ActivityDTO) {
        if (!activityDto.successful) {
            if (this.losesId) {
                this.historyService.notificationService.showError(activityDto?.error?.message);

                console.log('Command failed:', activityDto.error);
            }

            this.commandEnd(activityDto.successful);
        } else {
            const commandsArr = [];

            activityDto.links.forEach((linkJson: GtthLinkFeatureDtoModel) => {
                const link = this.historyService.logicalTopology.getLink(linkJson.getId());
                const modifyCommand = this.historyService.command(GtthModifyLinkInfoCommand).create(link.getId());
                modifyCommand.setOldLinkType(link.getLinkType());
                modifyCommand.setNewLinkType(linkJson.getLinkType());
                commandsArr.push(this.historyService.doCommandBypassHistory(modifyCommand, true));
            });

            Promise.all(commandsArr).then((_result) => {
                this.commandEnd(activityDto.successful);
            });
        }
    }

    private commandEnd(isSuccessful: boolean) {
        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.hide()
        });

        if (this.commandResolve) {
            this.commandResolve(isSuccessful);
        }
    }
}
